import { ButtonIcon, IconClear } from 'braid-design-system';
import type { ComponentProps } from 'react';

const HideJobButton = ({
  id,
  label,
  onClick,
}: {
  id: string;
  label: string;
  onClick: ComponentProps<typeof ButtonIcon>['onClick'];
}) => (
  <ButtonIcon
    id={id}
    variant="transparent"
    label={label}
    icon={<IconClear />}
    onClick={onClick}
    data={{ automation: 'hide-job-button' }}
  />
);
export default HideJobButton;
